import React, {useState, useEffect} from 'react';
import {Button, Card, message} from "antd";
import RequestListView from "../Request/RequestListView";
import {orderBy} from "lodash";
import EditRequest from './EditRequest';
import {findIndex} from 'lodash';
import {RedoOutlined} from "@ant-design/icons";
import {getTrnslationRequets} from "../../services/api.service";

const AdminDashboard = () => {
    const [tableData, setTableData] = useState([]);
    const [tblLoader, setTableLoader] = useState(false);
    const [modalState, setModalState] = useState(false);
    const [requestDetails, setRequestDetails] = useState({});

    useEffect(() => {
        getRequests();
    }, []);

    const modalHandler = (data, state) => {
        setRequestDetails({...data});
        setModalState(state);
        if (!state && data.id)
            updateTable(data)
    };

    const updateTable = (data) => {
        const requests = [...tableData];
        const index = findIndex(requests, {id: data.id});
        if (index >= 0) {
            requests[index] = {...data};
            setTableData(requests);
        }
    };

    const getRequests = async () => {
        try {
            setTableLoader(true);
            const {data} = await getTrnslationRequets();
            if (data.error) {
                message.error('Failed to fetch requests list');
                setTableLoader(false)
            } else {
                const sortedData = orderBy(data.data, ['createdAt'], ['desc']);
                setTableData([...sortedData]);
                setTableLoader(false)
            }
        } catch (err) {
            setTableLoader(false)
        }
    };

    return (
        <React.Fragment>
            <Card title="Translation Requests" extra={
                (
                    <React.Fragment>
                        <Button className="mr-2" onClick={() => getRequests()} icon={<RedoOutlined/>}
                                type="default">Refresh</Button>
                    </React.Fragment>
                )
            }>
                <RequestListView
                    tableData={tableData}
                    tblLoader={tblLoader} admin={true} editRequest={modalHandler}/>
            </Card>
            {modalState && <EditRequest
                data={requestDetails}
                modalState={modalState}
                toggleState={modalHandler}/>}
        </React.Fragment>
    )
};


export default AdminDashboard;
